__turbopack_context__.v({
  "blue": "FeatureCard-module-scss-module__ws2Z0W__blue",
  "boxWrapper": "FeatureCard-module-scss-module__ws2Z0W__boxWrapper",
  "button": "FeatureCard-module-scss-module__ws2Z0W__button",
  "chip": "FeatureCard-module-scss-module__ws2Z0W__chip",
  "chips": "FeatureCard-module-scss-module__ws2Z0W__chips",
  "container": "FeatureCard-module-scss-module__ws2Z0W__container",
  "content": "FeatureCard-module-scss-module__ws2Z0W__content",
  "description": "FeatureCard-module-scss-module__ws2Z0W__description",
  "green": "FeatureCard-module-scss-module__ws2Z0W__green",
  "image": "FeatureCard-module-scss-module__ws2Z0W__image",
  "list": "FeatureCard-module-scss-module__ws2Z0W__list",
  "listItem": "FeatureCard-module-scss-module__ws2Z0W__listItem",
  "orange": "FeatureCard-module-scss-module__ws2Z0W__orange",
  "pink": "FeatureCard-module-scss-module__ws2Z0W__pink",
  "reverse": "FeatureCard-module-scss-module__ws2Z0W__reverse",
  "video": "FeatureCard-module-scss-module__ws2Z0W__video",
});
